import { Card } from "@/components/ui/card";
import { X } from "lucide-react";
import { useState } from "react";

import { ChatDetail } from "./chat-detail.tsx";
import { ChatList } from "./chat-list.tsx";
import { cn } from "@/lib/utils.ts";

interface ChatPopupProps {
  onClose: () => void;
  isOpen: boolean;
  position: "left" | "right";
  isEscalationTriggerVisible: boolean;
}

export const ChatPopup = ({
  onClose,
  isOpen,
  position,
  isEscalationTriggerVisible,
}: ChatPopupProps) => {
  const [currentChannelUrl, setCurrentChannelUrl] = useState<string | null>(
    null,
  );

  return (
    <Card
      className={cn(
        "popup-chat absolute bottom-16 w-[500px] shadow-lg",
        position === "left" ? "left-0" : "right-0",
        !isOpen && "hidden",
        isEscalationTriggerVisible && "right-2",
      )}
    >
      {!currentChannelUrl && (
        <div className="flex items-center justify-between border-b p-4">
          <h2 className="text-lg font-semibold">Chats</h2>
          <button
            onClick={onClose}
            className="rounded-full p-1 hover:bg-gray-100"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      )}
      <div
        className={cn(
          "overflow-y-auto",
          !currentChannelUrl && "h-[640px]",
          currentChannelUrl && "h-[701px]",
        )}
      >
        {currentChannelUrl ? (
          <ChatDetail
            currentChannelUrl={currentChannelUrl}
            onBack={() => setCurrentChannelUrl(null)}
            onClose={onClose}
          />
        ) : (
          <ChatList
            currentChannelUrl={currentChannelUrl}
            onSelectChat={setCurrentChannelUrl}
          />
        )}
      </div>
    </Card>
  );
};
